import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#F9F6F0' }}>
        <div className="text-lg" style={{ color: '#990099' }}>Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !hasRole(roles)) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ backgroundColor: '#F9F6F0' }}>
        <div className="card p-8 text-center max-w-md" data-testid="access-denied">
          <h2 className="text-2xl font-bold mb-2" style={{ color: '#EF4444' }}>Access Denied</h2>
          <p style={{ color: '#6B7280' }}>You don't have permission to view this page.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
